import React, {useState} from 'react';

import Close from "../assets/Close.svg"

import styled, {css} from 'styled-components/macro'
import {AnimatePresence, motion} from "framer-motion";
import Spinner from "./Spinner";
import { Table } from 'reactstrap';
import App from "./App";

const Popup = styled(motion.div)`
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    background: rgba(0, 0, 0, 0.75);
    text-align: center;
    z-index: 3;
`

const PopupInner = styled(motion.div)`
    text-align: left;
    vertical-align: middle;
    position: absolute;
    max-width: 720px;
    width: 100%px;
    top:50%;
    left:50%;
    transform: translate(-50%, -50%);
    padding: 40px;
    
    background: #FFFFFF;
    box-shadow: 0px 8px 36px rgba(0, 0, 0, 0.16);
    border-radius: 16px;
    
    text-align: center;


`

const PopupHeader = styled.div`
    width: 100%;
    height: 24px;
    font-size: 19px;
    left: calc(50% - 623px/2);
    top: calc(50% - 24px/2 - 10px);
    line-height: 24px;
    font-weight: bold;
    display: flex;
    flex-direction: row;

    align-items: center;
    text-transform: capitalize;
`

const PopupSubHeader = styled.div`
    width: 100%;
    text-align: left;
    font-size: 16px;
    line-height: 24px;
    font-weight: bold;
    margin-top: -30px;
    margin-bottom: 20px;
    align-items: flex-start;
`


const CloseButton = styled.a`
    width: 24px;
    margin-left: 400px;
    height: 24px;
    float: right;
    cursor: pointer;
`

const ContentArea = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 40px;    
`

const PopupFooter = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 40px;

`

const PopupButton = styled.a`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
    
    position: relative;
    width: 300px;
    height: 42px;
    margin: 15px;
    background: transparent;
    color: #FAC44E;
    border: 2px solid #FAC44E;

    border-radius: 30px;
    ${props => props.primary && css`
        background: #FAC44E;
        color: white;
    `}
    
    ${props => props.disabled && css`
        opacity: 0.2;
    `}

    
    cursor: pointer;
`

const ProposalBox = styled.div`
    display: flex;
    flex-direction: column;
    width: 30%;
    align-items: flex-start;
    min-width: 334px;
    height: 200px;
    margin-left: 0px;
    margin-top: 0px;
    margin-right: 30px;
    margin-bottom: 30px;
    align-items: center;

    background: #FFFFFF;
    /* shadow 1 */
    
    box-shadow: 4px 6px 20px rgba(176, 176, 176, 0.15);
    border-radius: 6px;
`

const ProposalBoxLabel = styled.div`
    width: 100%;
    height: 18px;
    margin-top: 45px;
    margin-bottom: 5px;
    font-size: 26px;
    font-weight: bold;
    line-height: 100%;
    /* identical to box height, or 18px */

    text-align: center;
`

const ProposalBoxButton = styled(motion.button)`    
    justify-content: center;
    align-items: center;
    width: 60%;
    min-width: 238px;
    height: 50px;
    
    margin-top: 40px;

    /* yellow */
    background: linear-gradient(95.76deg, #FAC44E -0.92%, #F9AB12 96.25%);
    border-radius: 30px;
    border: none;
    
    font-weight: bold;
    font-size: 22px;
    
    /* or 25px */


    color: #FFFFFF;
    cursor: pointer;
    ${props => props.viewButton && css`
        border: 1px solid #F0C235;
        box-sizing: border-box;    
        border-radius: 41px;
        background: transparent;
        color: #FAC44E;
    `}
`

const ApprovalStatus = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 4px 16px;
    
    position: static;
    width: 93px;
    height: 25px;
    
    background: #4AA900;
    border-radius: 40px;
    color: white;
`

const PendingStatus = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 4px 16px;
    
    position: static;
    width: 93px;
    height: 25px;
    
    background: #FFCC2E;
    border-radius: 40px;
    color: white;
`

const modalVariant = {
    initial: { opacity: 0 },
    isOpen: { opacity: 1 },
    exit: { opacity: 0 }
};
const containerVariant = {
    initial: { top: "-50%", transition: { type: "spring" } },
    isOpen: { top: "50%" },
    exit: { top: "-50%" }
};


const ProposalViewModal = (props) => {
    const [modal, setModal] = useState(false);

    const [loading, setLoading] = useState(false);

    const toggle = () => {
        setLoading(false);
        setModal(!modal);
    };

    return (
        <AnimatePresence>
            <ProposalBox>
                <ProposalBoxLabel>{props.boxLabel}</ProposalBoxLabel>
                <ProposalBoxButton
                    whileHover={{scale: 1.1}}
                    whileTap={{scale: 0.9}}
                    onClick={toggle}
                    viewButton>View Proposal</ProposalBoxButton>
            {
                modal && (
            <Popup
                initial={"initial"}
                animate={"isOpen"}
                exit={"exit"}
                variants={modalVariant}>
                <PopupInner variants={containerVariant}>
                    <PopupHeader>
                        {props.header}
                        <CloseButton onClick={toggle}><img src={Close}/></CloseButton>
                    </PopupHeader>
                    { loading ? (<Spinner/>): (
                    <ContentArea>
                        {props.requestText === undefined ? ("") : (<PopupSubHeader>{props.requestText}</PopupSubHeader>)}
                        <Table>
                            <thead>
                            <tr>
                                <th>
                                    Management Address
                                </th>
                                <th>
                                    Status
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                                {props.boardMembers.map((member, index) => {
                                    return(
                                        <tr>
                                            <td>{member}</td>
                                            <td>{props.votingResults.includes(member) ? (<ApprovalStatus>APPROVED</ApprovalStatus>) : (<PendingStatus>PENDING</PendingStatus>)}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                    </ContentArea>
                    )}
                    <PopupFooter>
                        <PopupButton onClick={toggle}>Cancel</PopupButton>
                        <PopupButton primary disabled={props.votingResults.includes(props.caller)}
                            onClick={() => {
                                if(!props.votingResults.includes(props.caller)) {
                                    setLoading(true);
                                    props.action()
                                        .catch(()=>{
                                            setLoading(false);
                                        })
                                    }
                                }
                        }
                        >Approve</PopupButton>
                    </PopupFooter>
                </PopupInner>
            </Popup>
                )
            }
        </ProposalBox>
        </AnimatePresence>
            );
};

export default ProposalViewModal;
